class SessionStorageService {

    public getAccomodationSS() {
        return this.getItemSessionStorage('accomodation');
    }
    public getContactSS() {
        return this.getItemSessionStorage('contact');
    }
    public getLinkSS() {
        return this.getItemSessionStorage('link');
    }
    public getSocialSS() {
        return this.getItemSessionStorage('social');
    }
    public getLocationSS() {
        return this.getItemSessionStorage('location');
    }
    
    private getItemSessionStorage(item: string) {
        const cached = sessionStorage.getItem(item);
        if (cached) {
            return JSON.parse(cached)
        }
        return null
    }
}
export default new SessionStorageService();